import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row items-center justify-end" }

import {ref, computed} from 'vue';
  import { getCurrentDate } from 'src/services/utils/date';

  
export default /*#__PURE__*/_defineComponent({
  name: 'DateInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    errors: {
      type: Array,
      default: () => []
    },
    class: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Function,
      default: () => true,
    },
    todayButton: {
      type: Boolean,
      default: true
    },
    showBtnReset: {
      type: Boolean,
      default: true
    },
    showBtnClose: {
      type: Boolean,
      default: false
    },
  },
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

  
  
  const model = computed({
    get: () => {return props.modelValue},
    set: (value) => {return emit('update:modelValue', value || '')}
  });
  const extraClass = ref(props.class);
  const months = 'Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12'.split('_');
  const myLocale = {
    daysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    months: months,
    monthsShort: months,
  };
  const resetDate = () => {
    model.value = '';
  }
  const today = () => {
    model.value = getCurrentDate();
  }

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_input, {
    dense: "",
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    label: __props.label,
    placeholder: __props.placeholder || __props.format.toLowerCase(),
    error: !!__props.errors.length,
    class: _normalizeClass(extraClass.value),
    onkeypress: "return false",
    readonly: "",
    disable: __props.readonly
  }, {
    append: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: "event",
        class: "cursor-pointer"
      })
    ]),
    error: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.errors[0]), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_popup_proxy, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_date, {
            modelValue: _unref(model),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
            minimal: "",
            mask: __props.format,
            locale: myLocale,
            options: __props.options,
            disable: __props.readonly
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "Đóng",
                  color: "primary",
                  flat: ""
                }, null, 512), [
                  [_directive_close_popup],
                  [_vShow, __props.showBtnClose]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "Hiện tại",
                  color: "primary",
                  flat: "",
                  onClick: today
                }, null, 512), [
                  [_vShow, __props.todayButton]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "Đặt lại",
                  color: "primary",
                  flat: "",
                  onClick: resetDate,
                  disable: __props.readonly
                }, null, 8, ["disable"]), [
                  [_vShow, __props.showBtnReset]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "OK",
                  color: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('handClick'))),
                  flat: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "mask", "options", "disable"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "label", "placeholder", "error", "class", "disable"]))
}
}

})